import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  stepper: {
    cursor: 'pointer',
  },
}))
